import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useReducer, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { find as _find } from 'lodash';
import ReactDOM from 'react-dom';
import { Button, ButtonGroup, Col, FormText, Row, FormGroup, FormLabel, FormControl, Tabs, Tab } from 'react-bootstrap';
import { QRCodeSVG } from 'qrcode.react';
import withRouter from 'js/withRouter';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import ReactDOMServer from 'react-dom/server';
import { S3_LINKS } from 'js/constants';
import FormSwitchery from '../../../components/forms/FormSwitchery';
/* ---------- ContextModal (portal) ---------- */
const ContextModal = ({ children }) => {
    if (typeof document === 'undefined')
        return null;
    const el = document.getElementById('context-modal');
    if (!el)
        return null;
    return ReactDOM.createPortal(children, el);
};
const initialState = {
    showQRGen: false,
    src: [],
    key: 0,
    QRBackgroundColor: '#FFFFFF',
    QRFontColor: '#000000',
    QRBackgroundColorCache: '#FFFFFF',
    QRFontColorCache: '#000000',
    QRMargin: true,
    QRMarginCache: true,
    QRCodeLogo: '',
    QRCodeLogoCache: '',
    QRCodeAsString: '',
    QRCodeLogoWidth: 50,
    QRCodeLogoHeight: 50,
};
function reducer(state, action) {
    switch (action.type) {
        case 'initFromAttributes':
            return Object.assign(Object.assign({}, state), action.payload);
        case 'set':
            return Object.assign(Object.assign({}, state), { [action.key]: action.value });
        case 'setMultiple':
            return Object.assign(Object.assign({}, state), action.payload);
        case 'resetShow':
            return Object.assign(Object.assign({}, state), { showQRGen: false });
        default:
            return state;
    }
}
/* ---------- Helper: parseQR / getSrc / getQRCodeString ---------- */
const parseQR = (key, srcOutput) => {
    const srcObj = {};
    let srcString = '';
    switch (key) {
        // 1#cc#https://www.test.com#vcc#https://www.test.com
        // #cc# first url: coded in qrcode
        // #vcc# second link: form value
        case 1: {
            srcObj.url = srcOutput[1];
            srcObj.value = decodeURI(srcObj.url);
            srcString = srcObj.value + '#vcc#' + srcObj.url;
            break;
        }
        case 2: {
            // 2#cc#<VCARD_STRING>#vcc#name#vcc#org#vcc#title#vcc#tel#vcc#url#vcc#mail#vcc#adr#vcc#mobile
            // vCard
            srcObj.name = srcOutput[1];
            srcObj.org = srcOutput[2];
            srcObj.title = srcOutput[3];
            srcObj.tel = srcOutput[4];
            srcObj.url = srcOutput[5];
            srcObj.mail = srcOutput[6];
            srcObj.adr = srcOutput[7];
            srcObj.mobile = srcOutput === null || srcOutput === void 0 ? void 0 : srcOutput[8];
            srcObj.value =
                'BEGIN:VCARD\nVERSION:3.0' +
                    '\nN:' +
                    (srcObj.name || '') +
                    '\nORG:' +
                    (srcObj.org || '') +
                    '\nTITLE:' +
                    (srcObj.title || '') +
                    '\nTEL:' +
                    (srcObj.tel || '') +
                    '\nURL:' +
                    decodeURI(srcObj.url || '') +
                    '\nEMAIL:' +
                    (srcObj.mail || '') +
                    '\nADR:' +
                    (srcObj.adr || '') +
                    '\nTEL;TYPE=cell:' +
                    (srcObj.mobile || '') +
                    '\nEND:VCARD';
            srcString = srcObj.value;
            srcString += '#vcc#' + (srcObj.name || '');
            srcString += '#vcc#' + (srcObj.org || '');
            srcString += '#vcc#' + (srcObj.title || '');
            srcString += '#vcc#' + (srcObj.tel || '');
            srcString += '#vcc#' + (srcObj.url || '');
            srcString += '#vcc#' + (srcObj.mail || '');
            srcString += '#vcc#' + (srcObj.adr || '');
            srcString += '#vcc#' + (srcObj.mobile || '');
            break;
        }
        case 3: {
            // email message MATMSG
            // 3#cc#MATMSG:TO:max.mustermann@example.com;SUB:Hello World;BODY:Textmessage;;#vcc#max.mustermann@example.com#vcc#Hello%20World#vcc#Thats a text message
            srcObj.mail = srcOutput[1];
            srcObj.topic = srcOutput[2];
            srcObj.text = srcOutput[3];
            srcObj.value =
                'MATMSG:TO:' +
                    (srcObj.mail || '') +
                    ';SUB:' +
                    decodeURIComponent(srcObj.topic || '') +
                    ';BODY:' +
                    decodeURIComponent(srcObj.text || '') +
                    ';;';
            srcString = srcObj.value;
            srcString += '#vcc#' + (srcObj.mail || '');
            srcString += '#vcc#' + (srcObj.topic || '');
            srcString += '#vcc#' + (srcObj.text || '');
            break;
        }
        case 4: {
            // plain text
            // 4#cc#Hello World#vcc#Hello World
            srcObj.text = srcOutput[1];
            srcObj.value = srcObj.text;
            srcString = srcObj.value + '#vcc#' + srcObj.text;
            break;
        }
        default:
            srcObj.value = '#';
            srcString = srcObj.value;
            break;
    }
    return { src: srcObj, srcString };
};
const getSrcFromParamsOrInit = (params, attributes) => {
    const param = _find(params || [], ['name', attributes['data-name']]);
    const initQR = attributes['data-qr'] || false;
    if (param) {
        const output = param.value.split('#cc#');
        const srcOutput = output[1].split('#vcc#');
        return srcOutput[0];
    }
    if (initQR !== false && typeof initQR === 'string') {
        const output = initQR.split('#cc#');
        const srcOutput = output[1].split('#vcc#');
        return srcOutput[0];
    }
    return decodeURI('#');
};
const resolveVariablesForPreview = (rawValue, variables) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (!rawValue || !variables)
        return rawValue;
    let value = rawValue;
    const replacements = [
        ['website', (_a = variables.website) !== null && _a !== void 0 ? _a : ''],
        ['companyName', (_b = variables.companyName) !== null && _b !== void 0 ? _b : ''],
        ['addCompanyName', (_c = variables.addCompanyName) !== null && _c !== void 0 ? _c : ''],
        ['street', (_d = variables.street) !== null && _d !== void 0 ? _d : ''],
        ['zipCode', (_e = variables.zipCode) !== null && _e !== void 0 ? _e : ''],
        ['city', (_f = variables.city) !== null && _f !== void 0 ? _f : ''],
        ['phone', (_g = variables.phone) !== null && _g !== void 0 ? _g : ''],
        ['email', (_h = variables.email) !== null && _h !== void 0 ? _h : ''],
        ['slogan1', (_j = variables.slogan1) !== null && _j !== void 0 ? _j : ''],
        ['slogan2', (_k = variables.slogan2) !== null && _k !== void 0 ? _k : ''],
        ['herausgeber', (_l = variables.herausgeber) !== null && _l !== void 0 ? _l : ''],
    ];
    replacements.forEach(([key, val]) => {
        value = value.replace(new RegExp(`\\{${key}\\}`, 'gi'), val);
    });
    return value;
};
const getQRCodeString = (attributes, getSrcFn, qrBgColor, qrFontColor, qrMargin, qrCodeLogo, qrLogoWidth, qrLogoHeight, mValue) => {
    let imageSettings = null;
    if (typeof attributes['data-logo'] !== 'undefined') {
        imageSettings = {
            src: qrCodeLogo,
            excavate: true,
            height: qrLogoHeight,
            width: qrLogoWidth,
        };
    }
    else {
        imageSettings = null;
    }
    let srcToUse = '';
    if (mValue) {
        const srcOutput = mValue.split('#vcc#');
        srcToUse = srcOutput[0];
    }
    else {
        srcToUse = getSrcFn();
    }
    const qrcode = (_jsx(QRCodeSVG, { value: srcToUse, size: parseInt(attributes['data-size'], 10), bgColor: qrBgColor, fgColor: qrFontColor, level: "H", includeMargin: qrMargin, imageSettings: imageSettings !== null && imageSettings !== void 0 ? imageSettings : undefined }));
    return ReactDOMServer.renderToString(qrcode);
};
/* ---------- Component ---------- */
const QRCodeWithLogoFTs = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41;
    const { attributes, params = [], id, updateParam, settings = {}, intl, variables } = props;
    const messages = (intl && intl.messages) || ((_a = props === null || props === void 0 ? void 0 : props.appIntl) === null || _a === void 0 ? void 0 : _a.messages) || {};
    const [state, dispatch] = useReducer(reducer, initialState);
    // refs forwarded to inputs (React-Bootstrap FormControl supports ref forwarding)
    const qrUrlRef = useRef(null);
    const qrVCnameRef = useRef(null);
    const qrVCorgRef = useRef(null);
    const qrVCpositionRef = useRef(null);
    const qrVCtelRef = useRef(null);
    const qrVCmobileRef = useRef(null);
    const qrVCurlRef = useRef(null);
    const qrVCmailRef = useRef(null);
    const qrVCadrRef = useRef(null);
    const qrMailToRef = useRef(null);
    const qrMailTopicRef = useRef(null);
    const qrMailTextRef = useRef(null);
    const qrTextRef = useRef(null);
    const prevFirstParamValueRef = useRef(undefined);
    /* ---------- helpers derived from props/state ---------- */
    const getSrc = useCallback(() => getSrcFromParamsOrInit(params, attributes), [params, attributes]);
    /* ---------- load initial data and when params/attributes change ---------- */
    const getQRCodeData = useCallback(() => {
        var _a, _b, _c, _d;
        const param = _find(params || [], ['name', attributes['data-name']]);
        // colors, margin, logo, sizes from attributes or defaults
        const attrBg = typeof attributes['data-bg'] !== 'undefined' ? attributes['data-bg'] : '#FFFFFF';
        const attrColor = typeof attributes['data-color'] !== 'undefined' ? attributes['data-color'] : '#000000';
        const attrMargin = attributes['data-margin'] !== 'false';
        const attrLogo = typeof attributes['data-logo'] !== 'undefined' ? attributes['data-logo'] : '';
        const attrW = typeof attributes['data-width'] !== 'undefined' ? parseInt(attributes['data-width'], 10) : undefined;
        const attrH = typeof attributes['data-height'] !== 'undefined' ? parseInt(attributes['data-height'], 10) : undefined;
        dispatch({
            type: 'setMultiple',
            payload: Object.assign(Object.assign({ QRBackgroundColor: attrBg, QRBackgroundColorCache: attrBg, QRFontColor: attrColor, QRFontColorCache: attrColor, QRMargin: attrMargin, QRMarginCache: attrMargin, QRCodeLogo: attrLogo, QRCodeLogoCache: attrLogo }, (attrW && !Number.isNaN(attrW) ? { QRCodeLogoWidth: attrW } : {})), (attrH && !Number.isNaN(attrH) ? { QRCodeLogoHeight: attrH } : {})),
        });
        if (param) {
            const output = param.value.split('#cc#');
            // output format: key#cc#srcString#cc#size#cc#bg#cc#color#cc#margin#cc#logo#cc#qrString
            // guard indexes
            const bg = (_a = output[3]) !== null && _a !== void 0 ? _a : attrBg;
            const color = (_b = output[4]) !== null && _b !== void 0 ? _b : attrColor;
            const margin = ((_c = output[5]) !== null && _c !== void 0 ? _c : String(attrMargin)) === 'true';
            const logo = (_d = output[6]) !== null && _d !== void 0 ? _d : attrLogo;
            dispatch({
                type: 'setMultiple',
                payload: {
                    QRBackgroundColor: bg,
                    QRFontColor: color,
                    QRMargin: margin,
                    QRBackgroundColorCache: bg,
                    QRFontColorCache: color,
                    QRMarginCache: margin,
                    QRCodeLogo: logo,
                    QRCodeLogoCache: logo,
                },
            });
        }
        else {
            // if no param but attributes['data-qr'] exists, set/update param once
            const initQR = attributes['data-qr'] || false;
            if (!param && initQR !== false && typeof initQR === 'string') {
                const output = initQR.split('#cc#');
                const parsed = parseQR(parseInt(output[0], 10), output[1].split('#vcc#'));
                if (id && updateParam) {
                    const errors = [{ overflow: false, default_image: false }];
                    const built = parseInt(output[0], 10) +
                        '#cc#' +
                        parsed.srcString +
                        '#cc#' +
                        attributes['data-size'] +
                        '#cc#' +
                        attrBg +
                        '#cc#' +
                        attrColor +
                        '#cc#' +
                        (attrMargin ? 'true' : 'false') +
                        '#cc#' +
                        attrLogo +
                        '#cc#' +
                        getQRCodeString(attributes, getSrc, attrBg, attrColor, attrMargin, attrLogo, attrW, attrH);
                    updateParam(id, attributes['data-name'], built, errors);
                }
            }
        }
        // end getQRCodeData
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attributes, params, id, updateParam, getSrc]);
    useEffect(() => {
        var _a;
        // initial load on mount and when attributes/params change
        getQRCodeData();
        prevFirstParamValueRef.current = (_a = params === null || params === void 0 ? void 0 : params[0]) === null || _a === void 0 ? void 0 : _a.value;
    }, [getQRCodeData, params, attributes]);
    // watch param[0].value changes like in original componentDidUpdate
    useEffect(() => {
        var _a;
        const prev = prevFirstParamValueRef.current;
        const cur = (_a = params === null || params === void 0 ? void 0 : params[0]) === null || _a === void 0 ? void 0 : _a.value;
        if (prev !== undefined && prev !== cur) {
            getQRCodeData();
        }
        prevFirstParamValueRef.current = cur;
    }, [params, getQRCodeData]);
    /* ---------- UI event handlers ---------- */
    const updateQRBackgroundColor = useCallback((color) => {
        dispatch({ type: 'set', key: 'QRBackgroundColorCache', value: color });
    }, []);
    const updateQRFontColor = useCallback((color) => {
        dispatch({ type: 'set', key: 'QRFontColorCache', value: color });
    }, []);
    const updateQRMargin = useCallback((_name, value) => {
        dispatch({ type: 'set', key: 'QRMarginCache', value });
    }, []);
    const changeQRCodeColor = useCallback(() => {
        // apply cache into "live" state and write param
        const { QRBackgroundColorCache, QRFontColorCache, QRMarginCache, QRCodeLogoCache, QRCodeLogoWidth, QRCodeLogoHeight, } = state;
        dispatch({
            type: 'setMultiple',
            payload: {
                QRBackgroundColor: QRBackgroundColorCache,
                QRFontColor: QRFontColorCache,
                QRMargin: QRMarginCache,
                QRCodeLogo: QRCodeLogoCache,
            },
        }); // callback i. o.
        const param = _find(params || [], ['name', attributes['data-name']]);
        const initQR = attributes['data-qr'] || false;
        let output = [];
        if (param) {
            output = param.value.split('#cc#');
        }
        else if (!param && initQR !== false && typeof initQR === 'string') {
            output = initQR.split('#cc#');
        }
        if (!output || output.length === 0) {
            dispatch({ type: 'resetShow' });
            return;
        }
        const parsed = parseQR(parseInt(output[0], 10), output[1].split('#vcc#'));
        const errors = [{ overflow: false, default_image: false }];
        if (id && updateParam) {
            const built = parseInt(output[0], 10) +
                '#cc#' +
                parsed.srcString +
                '#cc#' +
                attributes['data-size'] +
                '#cc#' +
                QRBackgroundColorCache +
                '#cc#' +
                QRFontColorCache +
                '#cc#' +
                (QRMarginCache ? 'true' : 'false') +
                '#cc#' +
                QRCodeLogoCache +
                '#cc#' +
                getQRCodeString(attributes, getSrc, QRBackgroundColorCache, QRFontColorCache, QRMarginCache, QRCodeLogoCache, QRCodeLogoWidth, QRCodeLogoHeight);
            updateParam(id, attributes['data-name'], built, errors);
        }
        dispatch({ type: 'set', key: 'showQRGen', value: false });
    }, [attributes, params, state, id, updateParam, getSrc]);
    const openQRGen = useCallback(() => {
        let tmpSrc = { src: [] };
        tmpSrc.src = [];
        tmpSrc.src.url = '#';
        tmpSrc.src.value = '#';
        let k = 1;
        const param = _find(params || [], ['name', attributes['data-name']]);
        const initQR = attributes['data-qr'];
        if (param || initQR) {
            let output = [];
            if (param)
                output = param.value.split('#cc#');
            else
                output = initQR.split('#cc#');
            k = parseInt(output[0], 10);
            const parsed = parseQR(k, output[1].split('#vcc#'));
            tmpSrc = parsed.src;
        }
        dispatch({ type: 'setMultiple', payload: { showQRGen: true, src: tmpSrc, key: k } });
    }, [params, attributes]);
    const handleQRclose = useCallback(() => {
        dispatch({ type: 'set', key: 'showQRGen', value: false });
    }, []);
    const generateQR = useCallback(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const errors = [{ overflow: false, default_image: false }];
        let valueObj = { src: 'https://www.creacheck.com', srcString: 'https://www.creacheck.com' };
        const { key } = state;
        switch (key) {
            case 1:
                valueObj = parseQR(key, ['', ((_a = qrUrlRef.current) === null || _a === void 0 ? void 0 : _a.value) || '']);
                break;
            case 2:
                valueObj = parseQR(key, [
                    '',
                    ((_b = qrVCnameRef.current) === null || _b === void 0 ? void 0 : _b.value) || '',
                    ((_c = qrVCorgRef.current) === null || _c === void 0 ? void 0 : _c.value) || '',
                    ((_d = qrVCpositionRef.current) === null || _d === void 0 ? void 0 : _d.value) || '',
                    ((_e = qrVCtelRef.current) === null || _e === void 0 ? void 0 : _e.value) || '',
                    ((_f = qrVCurlRef.current) === null || _f === void 0 ? void 0 : _f.value) || '',
                    ((_g = qrVCmailRef.current) === null || _g === void 0 ? void 0 : _g.value) || '',
                    ((_h = qrVCadrRef.current) === null || _h === void 0 ? void 0 : _h.value) || '',
                    ((_j = qrVCmobileRef.current) === null || _j === void 0 ? void 0 : _j.value) || '',
                ]);
                break;
            case 3:
                valueObj = parseQR(key, [
                    '',
                    ((_k = qrMailToRef.current) === null || _k === void 0 ? void 0 : _k.value) || '',
                    ((_l = qrMailTopicRef.current) === null || _l === void 0 ? void 0 : _l.value) || '',
                    ((_m = qrMailTextRef.current) === null || _m === void 0 ? void 0 : _m.value) || '',
                ]);
                break;
            case 4:
                valueObj = parseQR(key, ['', ((_o = qrTextRef.current) === null || _o === void 0 ? void 0 : _o.value) || '']);
                break;
            default:
                valueObj = { src: '#', srcString: '#' };
                break;
        }
        if (id && updateParam) {
            const built = key +
                '#cc#' +
                valueObj.srcString +
                '#cc#' +
                attributes['data-size'] +
                '#cc#' +
                state.QRBackgroundColor +
                '#cc#' +
                state.QRFontColor +
                '#cc#' +
                (state.QRMargin ? 'true' : 'false') +
                '#cc#' +
                state.QRCodeLogo +
                '#cc#' +
                getQRCodeString(attributes, getSrc, state.QRBackgroundColorCache, state.QRFontColorCache, state.QRMarginCache, state.QRCodeLogo, state.QRCodeLogoWidth, state.QRCodeLogoHeight, valueObj.srcString);
            updateParam(id, attributes['data-name'], built, errors);
        }
        dispatch({ type: 'setMultiple', payload: { showQRGen: false, src: valueObj.src } });
    }, [
        state.key,
        state.QRBackgroundColor,
        state.QRFontColor,
        state.QRMargin,
        state.QRCodeLogo,
        state.QRBackgroundColorCache,
        state.QRFontColorCache,
        state.QRMarginCache,
        state.QRCodeLogoWidth,
        state.QRCodeLogoHeight,
        id,
        updateParam,
        attributes,
        getSrc,
    ]);
    const handleSelectLogo = useCallback((i) => {
        const source = S3_LINKS.TEMPLATES + (settings === null || settings === void 0 ? void 0 : settings.id) + '/images/';
        dispatch({ type: 'set', key: 'QRCodeLogoCache', value: source + (settings === null || settings === void 0 ? void 0 : settings.qrcode_logos[i]) });
    }, [settings]);
    const handleSelect = useCallback((k) => {
        const intKey = typeof k === 'string' ? parseInt(k, 10) : k;
        if (!Number.isNaN(intKey))
            dispatch({ type: 'set', key: 'key', value: intKey });
    }, []);
    /* ---------- derived UI pieces ---------- */
    const backColors = ((settings === null || settings === void 0 ? void 0 : settings.back_colors) || []).concat(((_b = settings === null || settings === void 0 ? void 0 : settings.target) === null || _b === void 0 ? void 0 : _b.back_colors) || []);
    const fontColors = ((settings === null || settings === void 0 ? void 0 : settings.font_colors) || []).concat(((_c = settings === null || settings === void 0 ? void 0 : settings.target) === null || _c === void 0 ? void 0 : _c.font_colors) || []);
    const source = S3_LINKS.TEMPLATES + (settings === null || settings === void 0 ? void 0 : settings.id) + '/images/';
    // prepare imageSettings for QRCodeSVG
    const imageSettings = typeof attributes['data-logo'] !== 'undefined'
        ? {
            src: state.QRCodeLogo,
            excavate: true,
            height: state.QRCodeLogoHeight,
            width: state.QRCodeLogoWidth,
        }
        : null;
    const Tag = (props.name || 'div');
    const rawSrc = getSrc();
    const qrValue = variables
        ? (() => {
            const resolved = resolveVariablesForPreview(rawSrc, variables);
            if (resolved && resolved.trim() !== '') {
                const hasUnresolved = /\{[a-zA-Z]+\}/.test(resolved);
                if (!hasUnresolved)
                    return decodeURI(resolved);
                const withoutPlaceholders = resolved.replace(/\{[^}]+\}/g, '').trim();
                if (withoutPlaceholders.length > 0)
                    return decodeURI(resolved);
            }
            return decodeURI('https://www.creacheck.com');
        })()
        : rawSrc;
    /* ---------- render ---------- */
    return (_jsxs("div", { className: "wrap", children: [_jsx(Tag, Object.assign({}, attributes, { onClick: openQRGen, "data-tooltip-content": "QR-Code", "data-tooltip-id": "top", children: _jsx(QRCodeSVG, { value: qrValue, size: parseInt(attributes['data-size'], 10), bgColor: state.QRBackgroundColor, fgColor: state.QRFontColor, level: "H", marginSize: state.QRMargin ? 4 : 0, imageSettings: imageSettings || undefined }) })), state.showQRGen && (_jsx(ContextModal, { children: _jsx("div", { id: "contextModalWrap", children: _jsxs("div", { id: "contextModalStage", className: "row", children: [_jsx("h5", { children: (_e = (_d = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _d === void 0 ? void 0 : _d.content_of_QRCode) !== null && _e !== void 0 ? _e : 'QR-Code content' }), _jsx("div", { id: "controlled-tab-qrcode", children: _jsxs(Tabs, { activeKey: state.key, onSelect: (k) => handleSelect(k), id: "controlled-tab-qrcode-single-tab", children: [_jsx(Tab, { eventKey: 1, title: "URL", children: _jsxs(FormGroup, { as: Row, controlId: "formURL", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_g = (_f = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _f === void 0 ? void 0 : _f.address_of_website) !== null && _g !== void 0 ? _g : 'Address of website' }), _jsxs(Col, { sm: 12, children: [_jsx(FormControl, { type: "text", defaultValue: resolveVariablesForPreview((_h = state.src) === null || _h === void 0 ? void 0 : _h.url, variables), placeholder: "https://www.beispiel.de", ref: qrUrlRef, "aria-describedby": "urlHelpBlock" }), _jsx(FormText, { id: "urlHelpBlock", children: (_k = (_j = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _j === void 0 ? void 0 : _j.must_url) !== null && _k !== void 0 ? _k : 'Must be a URL' })] })] }) }), _jsxs(Tab, { eventKey: 2, title: (_m = (_l = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _l === void 0 ? void 0 : _l.business_card) !== null && _m !== void 0 ? _m : 'Business card', children: [_jsxs(FormGroup, { as: Row, controlId: "formVCName", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_p = (_o = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _o === void 0 ? void 0 : _o.name_surname) !== null && _p !== void 0 ? _p : 'Name Surname' }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { type: "text", defaultValue: resolveVariablesForPreview((_q = state.src) === null || _q === void 0 ? void 0 : _q.name, variables), placeholder: "Max Mustermann", ref: qrVCnameRef }) })] }), _jsxs(FormGroup, { as: Row, controlId: "formVCOrg", children: [_jsx(FormLabel, { column: true, sm: 12, children: "Firma" }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { type: "text", defaultValue: resolveVariablesForPreview((_r = state.src) === null || _r === void 0 ? void 0 : _r.org, variables), placeholder: "Musterwerk GmbH", ref: qrVCorgRef }) })] }), _jsxs(FormGroup, { as: Row, controlId: "formVCPosition", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_t = (_s = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _s === void 0 ? void 0 : _s.position) !== null && _t !== void 0 ? _t : 'Position' }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { type: "text", defaultValue: resolveVariablesForPreview((_u = state.src) === null || _u === void 0 ? void 0 : _u.title, variables), placeholder: "Gesch\u00E4ftsf\u00FChrer", ref: qrVCpositionRef }) })] }), _jsxs(FormGroup, { as: Row, controlId: "formVCPHone", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_w = (_v = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _v === void 0 ? void 0 : _v.phone) !== null && _w !== void 0 ? _w : 'Phone' }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { type: "text", defaultValue: resolveVariablesForPreview((_x = state.src) === null || _x === void 0 ? void 0 : _x.tel, variables), placeholder: "+49 1234 56789", ref: qrVCtelRef }) })] }), _jsxs(FormGroup, { as: Row, controlId: "formVCMobile", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_y = messages === null || messages === void 0 ? void 0 : messages.mobile_phone) !== null && _y !== void 0 ? _y : 'Mobile phone' }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { type: "text", defaultValue: resolveVariablesForPreview((_z = state.src) === null || _z === void 0 ? void 0 : _z.mobile, variables), placeholder: "+49 160 111000", ref: qrVCmobileRef }) })] }), _jsxs(FormGroup, { as: Row, controlId: "formVCURL", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_1 = (_0 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _0 === void 0 ? void 0 : _0.website) !== null && _1 !== void 0 ? _1 : 'Website' }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { type: "text", defaultValue: resolveVariablesForPreview((_2 = state.src) === null || _2 === void 0 ? void 0 : _2.url, variables), placeholder: "www.musterwerk.de", ref: qrVCurlRef }) })] }), _jsxs(FormGroup, { as: Row, controlId: "formVCMail", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_4 = (_3 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _3 === void 0 ? void 0 : _3.email) !== null && _4 !== void 0 ? _4 : 'Email' }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { type: "text", defaultValue: resolveVariablesForPreview((_5 = state.src) === null || _5 === void 0 ? void 0 : _5.mail, variables), placeholder: "max.mustermann@musterwerk.de", ref: qrVCmailRef }) })] }), _jsxs(FormGroup, { as: Row, controlId: "formVCAdr", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_7 = (_6 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _6 === void 0 ? void 0 : _6.address) !== null && _7 !== void 0 ? _7 : 'Address' }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { type: "text", defaultValue: resolveVariablesForPreview((_8 = state.src) === null || _8 === void 0 ? void 0 : _8.adr, variables), placeholder: "Musterstr. 1, 01234 Musterhausen", ref: qrVCadrRef }) })] })] }), _jsxs(Tab, { eventKey: 3, title: (_10 = (_9 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _9 === void 0 ? void 0 : _9.email_message) !== null && _10 !== void 0 ? _10 : 'Email message', children: [_jsxs(FormGroup, { as: Row, controlId: "formMailTo", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_12 = (_11 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _11 === void 0 ? void 0 : _11.recipient_email_address) !== null && _12 !== void 0 ? _12 : 'Recipient email address' }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { type: "text", defaultValue: resolveVariablesForPreview((_13 = state.src) === null || _13 === void 0 ? void 0 : _13.mail, variables), placeholder: "nur-ein@beispiel.de", ref: qrMailToRef }) })] }), _jsxs(FormGroup, { as: Row, controlId: "formMailTopic", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_15 = (_14 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _14 === void 0 ? void 0 : _14.reference) !== null && _15 !== void 0 ? _15 : 'Reference' }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { type: "text", defaultValue: resolveVariablesForPreview((_16 = state.src) === null || _16 === void 0 ? void 0 : _16.topic, variables), placeholder: "Betreffzeile", ref: qrMailTopicRef }) })] }), _jsxs(FormGroup, { as: Row, controlId: "formMailText", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_18 = (_17 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _17 === void 0 ? void 0 : _17.content) !== null && _18 !== void 0 ? _18 : 'Content' }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { as: "textarea", defaultValue: resolveVariablesForPreview((_19 = state.src) === null || _19 === void 0 ? void 0 : _19.text, variables), placeholder: "Vordefinierter Text f\u00FCr die E-Mail", ref: qrMailTextRef }) })] })] }), _jsx(Tab, { eventKey: 4, title: (_21 = (_20 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _20 === void 0 ? void 0 : _20.text) !== null && _21 !== void 0 ? _21 : 'Text', children: _jsxs(FormGroup, { as: Row, controlId: "formTextContent", children: [_jsx(FormLabel, { column: true, sm: 12, children: (_23 = (_22 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _22 === void 0 ? void 0 : _22.your_text) !== null && _23 !== void 0 ? _23 : 'Your text' }), _jsx(Col, { sm: 12, children: _jsx(FormControl, { as: "textarea", defaultValue: resolveVariablesForPreview((_24 = state.src) === null || _24 === void 0 ? void 0 : _24.text, variables), placeholder: "Text der erscheint, wenn Qr-Code gescannt wird...", ref: qrTextRef }) })] }) }), _jsx(Tab, { eventKey: 5, title: (_25 = messages === null || messages === void 0 ? void 0 : messages.qr_settings) !== null && _25 !== void 0 ? _25 : 'QR Settings', children: _jsxs("div", { className: "changeColorOptions", style: { padding: '20px' }, children: [_jsxs(Row, { style: { marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #eaeaea' }, children: [_jsxs(Col, { xs: 6, md: 6, children: [_jsx("h4", { children: (_27 = (_26 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _26 === void 0 ? void 0 : _26.background_color) !== null && _27 !== void 0 ? _27 : 'Background color' }), _jsxs(ButtonGroup, { className: "edit-color QRBackground", size: "sm", children: [backColors &&
                                                                                backColors.map((bgColor) => {
                                                                                    var _a;
                                                                                    return (_jsx(Button, { variant: "light", "data-tooltip-content": (_a = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _a === void 0 ? void 0 : _a.change_backgroundcolor, onClick: () => updateQRBackgroundColor(bgColor.color), style: { padding: 4 }, children: _jsx("p", { style: { width: 30, height: 30, padding: 0, margin: 0, background: bgColor.color } }) }, bgColor.color));
                                                                                }), _jsx(Button, { variant: "light", "data-tooltip-content": (_28 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _28 === void 0 ? void 0 : _28.change_backgroundcolor, onClick: () => updateQRBackgroundColor('transparent'), style: { padding: 4 }, children: _jsx("p", { style: { width: 30, height: 30, padding: 0, margin: 0, background: 'transparent' } }) })] }), _jsx("h4", { children: (_30 = (_29 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _29 === void 0 ? void 0 : _29.color_of_qrcode) !== null && _30 !== void 0 ? _30 : 'Color of QR code' }), _jsx(ButtonGroup, { className: "edit-color QRFontColor", size: "sm", children: fontColors &&
                                                                            fontColors.map((bgColor, index) => {
                                                                                var _a;
                                                                                return (_jsx(Button, { variant: "light", "data-tooltip-content": (_a = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _a === void 0 ? void 0 : _a.change_backgroundcolor, onClick: () => updateQRFontColor(bgColor.color), style: { padding: 4 }, children: _jsx("p", { style: { width: 30, height: 30, padding: 0, margin: 0, background: bgColor.color } }) }, bgColor.color || index));
                                                                            }) })] }), _jsxs(Col, { xs: 6, md: 6, children: [_jsxs("div", { className: "QRCodeMargin", style: { marginTop: 0 }, children: [_jsx("h4", { children: (_31 = messages === null || messages === void 0 ? void 0 : messages.qr_margin) !== null && _31 !== void 0 ? _31 : 'QR margin' }), _jsx(FormSwitchery, { name: "margin", label: (_33 = (_32 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _32 === void 0 ? void 0 : _32.distance_to_border) !== null && _33 !== void 0 ? _33 : 'Distance to border', value: true, checked: state.QRMarginCache, onChange: updateQRMargin })] }), typeof attributes['data-logo'] !== 'undefined' && (_jsxs(_Fragment, { children: [_jsx("h4", { children: (_34 = messages === null || messages === void 0 ? void 0 : messages.qr_logo) !== null && _34 !== void 0 ? _34 : 'QR Logo' }), _jsx("div", { className: "qrcodeLogos", style: { display: 'flex', margin: '10px' }, children: ((settings === null || settings === void 0 ? void 0 : settings.qrcode_logos) || []).map((logo, i) => (_jsx("div", { style: { position: 'relative', borderBottom: '1px solid rgba(0,0,0,.07)' }, children: _jsx("img", { src: source + logo, alt: `QR Code Logo ${i}`, style: { width: 30, height: 30, margin: 5, cursor: 'pointer' }, onClick: () => handleSelectLogo(i) }) }, i))) })] }))] })] }), _jsx("p", { children: (_35 = messages === null || messages === void 0 ? void 0 : messages.qr_example) !== null && _35 !== void 0 ? _35 : 'QR example' }), _jsxs("div", { className: "showQRExample", style: { margin: 'margin 0 auto', marginTop: 10, marginBottom: 20, width: 150, height: 150 }, children: [_jsx("div", { className: "showQR", style: { height: 150, width: 150, position: 'absolute', zIndex: 1 }, children: _jsxs("svg", { shapeRendering: "crispEdges", height: "150", width: "150", viewBox: "0 0 33 33", children: [_jsx("path", { fill: state.QRBackgroundColorCache, d: "M0,0 h33v33H0z" }), _jsx("path", { fill: state.QRFontColorCache, d: "M4 4h7v1H4zM14 4h1v1H14zM16 4h2v1H16zM20 4h1v1H20zM22,4 h7v1H22zM4 5h1v1H4zM10 5h1v1H10zM12 5h1v1H12zM14 5h1v1H14zM19 5h2v1H19zM22 5h1v1H22zM28,5 h1v1H28zM4 6h1v1H4zM6 6h3v1H6zM10 6h1v1H10zM16 6h1v1H16zM22 6h1v1H22zM24 6h3v1H24zM28,6 h1v1H28zM4 7h1v1H4zM6 7h3v1H6zM10 7h1v1H10zM12 7h3v1H12zM16 7h4v1H16zM22 7h1v1H22zM24 7h3v1H24zM28,7 h1v1H28zM4 8h1v1H4zM6 8h3v1H6zM10 8h1v1H10zM13 8h1v1H13zM20 8h1v1H20zM22 8h1v1H22zM24 8h3v1H24zM28,8 h1v1H28zM4 9h1v1H4zM10 9h1v1H10zM12 9h2v1H12zM15 9h2v1H15zM18 9h3v1H18zM22 9h1v1H22zM28,9 h1v1H28zM4 10h7v1H4zM12 10h1v1H12zM14 10h1v1H14zM16 10h1v1H16zM18 10h1v1H18zM20 10h1v1H20zM22,10 h7v1H22zM13 11h3v1H13zM18 11h2v1H18zM4 12h5v1H4zM10 12h4v1H10zM15 12h1v1H15zM17 12h3v1H17zM21 12h1v1H21zM23 12h1v1H23zM25 12h1v1H25zM27 12h1v1H27zM4 13h4v1H4zM11 13h2v1H11zM14 13h1v1H14zM16 13h1v1H16zM20 13h2v1H20zM23 13h1v1H23zM27 13h1v1H27zM6 14h2v1H6zM9 14h2v1H9zM14 14h1v1H14zM17 14h1v1H17zM19 14h7v1H19zM27,14 h2v1H27zM4 15h1v1H4zM6 15h1v1H6zM8 15h1v1H8zM12 15h1v1H12zM16 15h1v1H16zM18 15h4v1H18zM23 15h1v1H23zM28,15 h1v1H28zM5 16h2v1H5zM8 16h1v1H8zM10 16h2v1H10zM13 16h2v1H13zM16 16h4v1H16zM21 16h4v1H21zM26,16 h3v1H26zM4 17h1v1H4zM6 17h1v1H6zM8 17h2v1H8zM11 17h2v1H11zM17 17h1v1H17zM20 17h2v1H20zM23 17h1v1H23zM25 17h1v1H25zM27 17h1v1H27zM4 18h1v1H4zM10 18h2v1H10zM13 18h5v1H13zM19 18h1v1H19zM21 18h5v1H21zM27,18 h2v1H27zM4 19h1v1H4zM7 19h2v1H7zM12 19h2v1H12zM15 19h1v1H15zM18 19h1v1H18zM21 19h1v1H21zM23 19h2v1H23zM28,19 h1v1H28zM4 20h1v1H4zM6 20h1v1H6zM9 20h3v1H9zM15 20h3v1H15zM19 20h6v1H19zM26 20h1v1H26zM12 21h1v1H12zM14 21h1v1H14zM16 21h2v1H16zM20 21h1v1H20zM24 21h2v1H24zM4 22h7v1H4zM12 22h3v1H12zM17 22h2v1H17zM20 22h1v1H20zM22 22h1v1H22zM24 22h1v1H24zM26,22 h3v1H26zM4 23h1v1H4zM10 23h1v1H10zM20 23h1v1H20zM24 23h2v1H24zM27,23 h2v1H27zM4 24h1v1H4zM6 24h3v1H6zM10 24h1v1H10zM12 24h1v1H12zM15 24h10v1H15zM26 24h1v1H26zM4 25h1v1H4zM6 25h3v1H6zM10 25h1v1H10zM12 25h2v1H12zM15 25h1v1H15zM20 25h1v1H20zM22 25h1v1H22zM24,25 h5v1H24zM4 26h1v1H4zM6 26h3v1H6zM10 26h1v1H10zM12 26h2v1H12zM17 26h1v1H17zM19 26h1v1H19zM25 26h2v1H25zM28,26 h1v1H28zM4 27h1v1H4zM10 27h1v1H10zM12 27h1v1H12zM14 27h2v1H14zM18 27h4v1H18zM23 27h3v1H23zM28,27 h1v1H28zM4 28h7v1H4zM12 28h1v1H12zM14 28h5v1H14zM23,28 h6v1H23z" })] }) }), typeof attributes['data-logo'] !== 'undefined' && (_jsx("div", { className: "showQRLogo", style: {
                                                                    position: 'absolute',
                                                                    backgroundColor: state.QRBackgroundColorCache !== 'transparent'
                                                                        ? state.QRBackgroundColorCache
                                                                        : '#FFFFFF',
                                                                    height: '50px',
                                                                    width: '50px',
                                                                    zIndex: 2,
                                                                    transform: 'translate(50px, 50px)',
                                                                }, children: _jsx("img", { src: state.QRCodeLogoCache, alt: "QRCodeLogo", style: { width: '100%', height: '100%' } }) }))] })] }) })] }) }), state.key !== 5 ? (_jsx(Button, { className: "cm-max-width", variant: "success", size: "lg", onClick: generateQR, children: (_37 = (_36 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _36 === void 0 ? void 0 : _36.add_QRCode) !== null && _37 !== void 0 ? _37 : 'Add QRCode' })) : (_jsx(Button, { variant: "success", size: "lg", onClick: () => changeQRCodeColor(), className: "cancelIE changeQRCodeColor", children: (_39 = (_38 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _38 === void 0 ? void 0 : _38.take_on) !== null && _39 !== void 0 ? _39 : 'Take on' })), _jsx(Button, { variant: "danger", size: "lg", onClick: handleQRclose, className: "cancelIE", children: (_41 = (_40 = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _40 === void 0 ? void 0 : _40.abort) !== null && _41 !== void 0 ? _41 : 'Abort' })] }) }) }))] }));
};
/* ---------- Redux wiring ---------- */
const mapStateToProps = (state) => ({
    appIntl: state.intl,
});
export default withRouter(connect(mapStateToProps)(legacyInjectIntl(QRCodeWithLogoFTs)));
